import styled from 'styled-components'
import { Button } from '../../atoms/Button'

export const AnalysisFilterSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.background};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};
  flex-shrink: 0;
`

export const AnalysisFilterBar = styled.div`
  padding: 20px 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  min-height: 68px;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }
`

export const AnalysisLocationFilters = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  flex-wrap: wrap;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: column;
    align-items: stretch;
  }
`

export const AnalysisFilterChip = styled.div<{ $active?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  background: ${({ theme, $active }) =>
    $active ? theme.colors.primary + '20' : theme.colors.background.secondary};
  color: ${({ theme, $active }) =>
    $active ? theme.colors.primary : theme.colors.text.primary};
  border: 1px solid
    ${({ theme, $active }) =>
      $active ? theme.colors.primary : theme.colors.border.light};
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  user-select: none;

  &:hover {
    background: ${({ theme, $active }) =>
      $active ? theme.colors.primary + '30' : theme.colors.background.tertiary};
    border-color: ${({ theme, $active }) =>
      $active ? theme.colors.primary : theme.colors.border.default};
    transform: translateY(-1px);
    box-shadow: ${({ theme }) => theme.shadows.sm};
  }

  &:active {
    transform: translateY(0);
  }

  svg {
    width: 14px;
    height: 14px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 8px 16px;
    font-size: 14px;
    flex: 1;
    justify-content: center;
  }
`

export const AnalysisLocationBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  color: ${({ theme }) => theme.colors.text.primary};
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;

  svg {
    width: 12px;
    height: 12px;
  }
`

export const AnalysisFilterActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: 100%;
    justify-content: space-between;
  }
`

export const AnalysisFilterToggleButton = styled(Button)`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 500;
  border-radius: 8px;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex: 1;
  }
`

export const AnalysisActiveFiltersCount = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  background: ${({ theme }) => theme.colors.primary};
  color: white;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
  margin-left: 4px;
`

export const AnalysisAdvancedFiltersPanel = styled.div<{ $isOpen: boolean }>`
  display: ${({ $isOpen }) => ($isOpen ? 'block' : 'none')};
  border-top: ${({ theme, $isOpen }) =>
    $isOpen ? `1px solid ${theme.colors.border.light}` : 'none'};
`

export const AnalysisAdvancedFiltersContent = styled.div`
  padding: 20px 24px;
  background: ${({ theme }) => theme.colors.background.secondary + '50'};
`

export const AnalysisDivider = styled.div`
  width: 1px;
  height: 16px;
  background: ${({ theme }) => theme.colors.border.light};
`
